import React from 'react';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import * as styles from './styles.module.scss';

// different enough from Button I kept this a separate component; 6s
const AnchorButton: React.FC<{ href: string; onClick?: () => void }> = ({ children, href, onClick }) => (
  <a className={styles.anchor} href={checkLinkAndAppendLanguage(href)} {...(onClick && { onClick })}>
    {children}
  </a>
);

export default AnchorButton;
